﻿import ReduxThunk from 'redux-thunk';
import { createStore, combineReducers, Store, applyMiddleware } from 'redux';
import VeilederBarnestipendDto from '../Models/VeilederBarnestipendDto';
import { epiContextReducer } from '../../Shared/Scripts/Store/EpiContext/Reducers';
import { resultatReducer } from './Resultat/Reducers';
import { EpiContext, UpdateEpiContextActionTypes } from '../../Shared/Scripts/Store/EpiContext/Types';
import { stegVisningReducer } from '../../Shared/Scripts/Store/StegVisning/Reducers';
import { EpiAppStateMedSteg } from '../../Shared/Scripts/Store/Types';
import { valgReducer } from './Valg/Reducers';
import { satserReducer } from '../../Shared/Scripts/Store/Satser/Reducers';
import { BarnestipendSatser } from '../Utilities/BarnestipendApi';

const rootReducer = combineReducers<VeilederBarnestipendAppState>({
    valg: valgReducer,
    resultat: resultatReducer,
    satser: satserReducer,
    epiContext: (
        state: EpiContext<VeilederBarnestipendDto> | undefined,
        action: UpdateEpiContextActionTypes<VeilederBarnestipendDto>,
    ): EpiContext<VeilederBarnestipendDto> => epiContextReducer(state, action),
    stegVisning: stegVisningReducer,
});

export type VeilederBarnestipendAppState = EpiAppStateMedSteg<VeilederBarnestipendDto> & {
    valg: ReturnType<typeof valgReducer>;
    resultat: ReturnType<typeof resultatReducer>;
    satser: BarnestipendSatser | null;
};

export default function configureStore(): Store<VeilederBarnestipendAppState> {
    return createStore(rootReducer, applyMiddleware(ReduxThunk));
}
